// extracted by mini-css-extract-plugin
module.exports = {"root":"ob_UU25Or","loader":"ob_n7rs2u","footer":"ob_Qfi78m","footer__content":"ob_abkOvj","footer__list":"ob_ds2F66","footer__actions":"ob_zaG7Gq","footer__login":"ob_XwDWf6"};